/* PROTOCOL flow v6 · back button

   Three different behaviours before this:
     join-protocol : prevStep() decremented to step 0 and called showPanel(0).
                     With the gate removed there is no panel 0, so it threw
                     "Cannot read properties of null" and the button was dead.
     add-ons       : prevStep() -> back_link -> the homepage.
     renew         : prevStep() -> back_link -> the homepage.

   All three now return to the Core Health Test page, which is where the
   person came from and the only page that can re-sell them if they leave.
   Payment is Shopify checkout and lives off-site, so within these flows
   there is only ever one step: back always means leave. */
(function(){
  'use strict';
  var CHT = '/core-health-test';

  function goBack(){
    /* if the visitor arrived from the CHT page, a real history step keeps
       their scroll position; otherwise send them there fresh */
    try{
      if(document.referrer && document.referrer.indexOf(location.host) > -1 &&
         document.referrer.indexOf('core-health-test') > -1){
        history.back();
        return;
      }
    }catch(e){}
    window.location.href = CHT;
  }

  function apply(){
    window.prevStep = goBack;
    document.querySelectorAll('.back').forEach(function(b){
      b.setAttribute('onclick','prevStep()');
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ apply(); setTimeout(apply, 600); });
  } else {
    apply(); setTimeout(apply, 600);
  }
})();
